import { createSlice } from "@reduxjs/toolkit";
import CustomAxios from "../utilities/service/api.service";
import CheckAuthorization from "../utilities/auth/checkAuthorization";
import { API } from "../utilities/constants";

const initialState = {
  app_role_nielsen: "",
  loadingNielsen: 0,
  nielsendropdownLoading: 0,
  nielsentableLoading: 0,
  loadingExportDataNielsen: 0,
  prod_data_filters_nielsen: {},
  cust_data_filters_nielsen: {},
  prod_filters_nielsen: {
    product_pet: [],
    product_portfolio: [],
    product_technology: [],
    product_manufacturer: [],
    product_brand: [],
    product_local_manufacturer: [],
    product_local_brand: [],
    product_sub_brand: [],
    product_pack_format: [],
    product_pack_size: [],
    product_number_in_pack: [],
    product_pack_type: [],
    product_ppg: [],
    product_flavour: [],
    product_size: [],
    product_description: [],
    product_long_description: [],
    product_ean_code: [],
    Growth_Drivers: [],
    periodicity: [],
    time_frames: [],
  },
  cust_filters_nielsen: {
    customer_type: [],
    customer_retail: [],
    customer_channel: [],
    customer_market: [],
    customer_desc: [],
    kpis: [],
  },
  customerFiltersWeekly: {
    customer_type: [],
    customer_retail: [],
    customer_channel: [],
    customer_market: [],
    customer_desc: [],
  },
  kpis_in_api_nielsen: {},
  groupBy: [],
  customer_type: [],
  customer_retail: [],
  customer_channel: [],
  customer_market: [],
  customer_desc: [],
  product_pet: [],
  product_portfolio: [],
  product_technology: [],
  product_manufacturer: [],
  product_brand: [],
  product_local_manufacturer: [],
  product_local_brand: [],
  product_sub_brand: [],
  product_pack_format: [],
  product_pack_size: [],
  product_number_in_pack: [],
  product_pack_type: [],
  product_ppg: [],
  product_flavour: [],
  product_size: [],
  product_description: [],
  product_long_description: [],
  product_ean_code: [],
  Growth_Drivers: [],
  periodicity: [],
  nielsentabledataPreview: [],
  nielsentabledataPreviewColumns: [],
  kpis: [],
  time_frames_nielsen: [],
  nielsentimePeriodCheckbox: ["l4w"],
  nielsenYear: [],
  nielsenYearPeriod: [],
  nielsenYearPeriodWeek: [],
  nielsentimeframeCheckbox: [],
  timeHorizonRadioNielsen: "rolledup",
  numOfRows: 0,
  numOfColumns: 0,
  nielsen_columnSelectionCheckbox: [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "customer_id__customer_desc",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
  ],
  nielsen_dataset_selected: "nielsen",
  includeAllCheckbox_nielsen: [""],
  includeAllLevelsonLoad: [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "customer_id__customer_desc",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
  ],
  export_Data_nielsen: [],
  email_address_nielsen: "",
  previewFormatNielsen: false,
  timeSelectedDynamicNielsen: [],
  nameofNielsenBookmark: [],
  nielsen_bookmark_data: [],
};

const nielsenfiltersSlicer = createSlice({
  name: "nielsenfilters",
  initialState,
  reducers: {
    setAppRoleNielsenPage: (state, action) => ({
      ...state,
      app_role_nielsen: action.payload,
    }),
    setLoadingNielsen: (state, action) => ({
      ...state,
      loadingNielsen: state.loadingNielsen + (action.payload ? 1 : -1),
    }),
    setNielsenDropdownLoading: (state, action) => ({
      ...state,
      nielsendropdownLoading:
        state.nielsendropdownLoading + (action.payload ? 1 : -1),
    }),
    setNielsenTableLoading: (state, action) => ({
      ...state,
      nielsentableLoading:
        state.nielsentableLoading + (action.payload ? 1 : -1),
    }),
    setNielsenExportDataLoading: (state, action) => ({
      ...state,
      loadingExportDataNielsen:
        state.loadingExportData + (action.payload ? 1 : -1),
    }),
    setNielsenProdFilters: (state, action) => ({
      ...state,
      prod_filters_nielsen: action.payload,
    }),
    setNielsenCustFilters: (state, action) => ({
      ...state,
      cust_filters_nielsen: action.payload,
    }),
    setNielsenWeeklyCustFilters: (state, action) => ({
      ...state,
      customerFiltersWeekly: action.payload,
    }),
    setGroupBy: (state, action) => ({
      ...state,
      groupBy: action.payload,
    }),
    setNielsenProdDataFilters: (state, action) => ({
      ...state,
      prod_data_filters_nielsen: action.payload,
    }),
    setNielsenCustDataFilters: (state, action) => ({
      ...state,
      cust_data_filters_nielsen: action.payload,
    }),
    setNielsenKPIs: (state, action) => ({
      ...state,
      kpis_in_api_nielsen: action.payload,
    }),
    setNielsenDataDropdown: (state, action) => ({
      ...state,
      [action.payload[0]]: action.payload[1],
    }),
    setNielsenTableDataPreview: (state, action) => ({
      ...state,
      nielsentabledataPreview: action.payload,
    }),
    setNielsenTableDataPreviewColumns: (state, action) => ({
      ...state,
      nielsentabledataPreviewColumns: action.payload,
    }),
    setnielsenTimePeriodCheckbox: (state, action) => ({
      ...state,
      nielsentimePeriodCheckbox: action.payload,
    }),
    setNielsenYear: (state, action) => ({
      ...state,
      nielsenYear: action.payload,
    }),
    setNielsenYearPeriod: (state, action) => ({
      ...state,
      nielsenYearPeriod: action.payload,
    }),
    setNielsenYearPeriodWeek: (state, action) => ({
      ...state,
      nielsenYearPeriodWeek: action.payload,
    }),
    setnielsenTimeframeCheckbox: (state, action) => ({
      ...state,
      nielsentimeframeCheckbox: action.payload,
    }),
    setNielsenTimeHorizonRadio: (state, action) => ({
      ...state,
      timeHorizonRadioNielsen: action.payload,
    }),
    setTimeSelectedDynamicWeeklyNielsen: (state, action) => ({
      ...state,
      timeSelectedDynamicNielsen: action.payload,
    }),
    setnumOfRows: (state, action) => ({
      ...state,
      numOfRows: action.payload,
    }),
    setnumOfColumns: (state, action) => ({
      ...state,
      numOfColumns: action.payload,
    }),
    setnielsencolumnSelectionCheckbox: (state, action) => ({
      ...state,
      nielsen_columnSelectionCheckbox: action.payload,
    }),
    setDatasetNielsen: (state, action) => ({
      ...state,
      nielsen_dataset_selected: action.payload,
    }),
    setincludeAllCheckboxNielsen: (state, action) => ({
      ...state,
      includeAllCheckbox_nielsen: action.payload,
    }),
    setNielsenExportData: (state, action) => ({
      ...state,
      export_Data_nielsen: action.payload,
    }),
    setEmailAddressNielsen: (state, action) => ({
      ...state,
      email_address_nielsen: action.payload,
    }),
    setPreviewFormatNielsen: (state, action) => ({
      ...state,
      previewFormatNielsen: action.payload,
    }),
    setNameofBookmarkNielsen: (state, action) => ({
      ...state,
      nameofNielsenBookmark: action.payload,
    }),
    setNielsenBookmarkData: (state, action) => ({
      ...state,
      nielsen_bookmark_data: action.payload,
    }),
  },
});

export const {
  setAppRoleNielsenPage,
  setLoadingNielsen,
  setNielsenDropdownLoading,
  setNielsenTableLoading,
  setNielsenExportDataLoading,
  setNielsenProdFilters,
  setNielsenCustFilters,
  setNielsenWeeklyCustFilters,
  setGroupBy,
  setNielsenProdDataFilters,
  setNielsenCustDataFilters,
  setNielsenKPIs,
  setNielsenDataDropdown,
  setNielsenTableDataPreview,
  setNielsenTableDataPreviewColumns,
  setnielsenTimePeriodCheckbox,
  setNielsenYear,
  setNielsenYearPeriod,
  setNielsenYearPeriodWeek,
  setnielsenTimeframeCheckbox,
  setNielsenTimeHorizonRadio,
  setTimeSelectedDynamicWeeklyNielsen,
  setnumOfRows,
  setnumOfColumns,
  setnielsencolumnSelectionCheckbox,
  setDatasetNielsen,
  setincludeAllCheckboxNielsen,
  setNielsenExportData,
  setEmailAddressNielsen,
  setPreviewFormatNielsen,
  setNameofBookmarkNielsen,
  setNielsenBookmarkData,
} = nielsenfiltersSlicer.actions;
//function for obtaining data in product filters dropdowns
export const getNielsenProductFilters =
  (filters) => async (dispatch, getState) => {
    let urlFilters = { ...filters };
    Object.keys(urlFilters).forEach((key) => {
      if (urlFilters[key].length === 0) {
        delete urlFilters[key];
      }
    });
    dispatch(setNielsenDropdownLoading(true));
    CustomAxios(API.nielsen_dropdowns + "?dim=product", "POST", urlFilters)
      .then((response) => {
        if (response.data.error_code === undefined) {
          let data_filters = response.data;
          dispatch(setNielsenProdDataFilters(data_filters));
          data_filters.product_pet &&
            data_filters.product_pet.length &&
            dispatch(
              setNielsenDataDropdown(["product_pet", data_filters.product_pet])
            );
          data_filters.product_portfolio &&
            data_filters.product_portfolio.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_portfolio",
                data_filters.product_portfolio,
              ])
            );
          data_filters.product_technology &&
            data_filters.product_technology.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_technology",
                data_filters.product_technology,
              ])
            );
          data_filters.product_manufacturer &&
            data_filters.product_manufacturer.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_manufacturer",
                data_filters.product_manufacturer,
              ])
            );
          data_filters.product_brand &&
            data_filters.product_brand.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_brand",
                data_filters.product_brand,
              ])
            );
          data_filters.product_local_manufacturer &&
            data_filters.product_local_manufacturer.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_local_manufacturer",
                data_filters.product_local_manufacturer,
              ])
            );
          data_filters.product_local_brand &&
            data_filters.product_local_brand.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_local_brand",
                data_filters.product_local_brand,
              ])
            );
          data_filters.product_sub_brand &&
            data_filters.product_sub_brand.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_sub_brand",
                data_filters.product_sub_brand,
              ])
            );
          data_filters.product_pack_format &&
            data_filters.product_pack_format.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_pack_format",
                data_filters.product_pack_format,
              ])
            );
          data_filters.product_pack_size &&
            data_filters.product_pack_size.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_pack_size",
                data_filters.product_pack_size,
              ])
            );
          data_filters.product_number_in_pack &&
            data_filters.product_number_in_pack.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_number_in_pack",
                data_filters.product_number_in_pack,
              ])
            );
          data_filters.product_pack_type &&
            data_filters.product_pack_type.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_pack_type",
                data_filters.product_pack_type,
              ])
            );
          data_filters.product_ppg &&
            data_filters.product_ppg.length &&
            dispatch(
              setNielsenDataDropdown(["product_ppg", data_filters.product_ppg])
            );
          data_filters.product_flavour &&
            data_filters.product_flavour.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_flavour",
                data_filters.product_flavour,
              ])
            );
          data_filters.product_size &&
            data_filters.product_size.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_size",
                data_filters.product_size,
              ])
            );
          data_filters.product_description &&
            data_filters.product_description.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_description",
                data_filters.product_description,
              ])
            );
          data_filters.product_long_description &&
            data_filters.product_long_description.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_long_description",
                data_filters.product_long_description,
              ])
            );
          data_filters.product_ean_code &&
            data_filters.product_ean_code.length &&
            dispatch(
              setNielsenDataDropdown([
                "product_ean_code",
                data_filters.product_ean_code,
              ])
            );
            data_filters.Growth_Drivers &&
            data_filters.Growth_Drivers.length &&
            dispatch(
              setNielsenDataDropdown([
                "Growth_Drivers",
                data_filters.Growth_Drivers,
              ])
            );
          data_filters.periodicity &&
            data_filters.periodicity.length &&
            dispatch(
              setNielsenDataDropdown(["periodicity", data_filters.periodicity])
            );
          data_filters.time_frames &&
            data_filters.time_frames.length &&
            dispatch(
              setNielsenDataDropdown(["time_frames", data_filters.time_frames])
            );
        }
        dispatch(setNielsenDropdownLoading(false));
      })
      .catch((err) => {
        console.error("Nielsen Product Data Filters Dropdown API Failed", err);
        if (err.status === 403) {
          CheckAuthorization();
        }
        dispatch(setNielsenDropdownLoading(false));
      });
  };
//function for obtaining data in customer filters dropdowns
export const getNielsenCustomerFilters =
  (filters) => async (dispatch, getState) => {
    let urlFilters = { ...filters };
    Object.keys(urlFilters).forEach((key) => {
      if (urlFilters[key].length === 0) {
        delete urlFilters[key];
      }
    });
    dispatch(setNielsenDropdownLoading(true));
    CustomAxios(API.nielsen_dropdowns + "?dim=customer", "POST", urlFilters)
      .then((response) => {
        if (response.data.error_code === undefined) {
          let cust_data_filters = response.data;
          dispatch(setNielsenCustDataFilters(cust_data_filters));
          cust_data_filters.periodicity &&
            cust_data_filters.periodicity.length &&
            dispatch(
              setNielsenDataDropdown([
                "periodicity",
                cust_data_filters.periodicity,
              ])
            );
          cust_data_filters.customer_channel &&
            cust_data_filters.customer_channel.length &&
            dispatch(
              setNielsenDataDropdown([
                "customer_channel",
                cust_data_filters.customer_channel,
              ])
            );
          cust_data_filters.customer_market &&
            cust_data_filters.customer_market.length &&
            dispatch(
              setNielsenDataDropdown([
                "customer_market",
                cust_data_filters.customer_market,
              ])
            );
          cust_data_filters.customer_retail &&
            cust_data_filters.customer_retail.length &&
            dispatch(
              setNielsenDataDropdown([
                "customer_retail",
                cust_data_filters.customer_retail,
              ])
            );
          cust_data_filters.customer_type &&
            cust_data_filters.customer_type.length &&
            dispatch(
              setNielsenDataDropdown([
                "customer_type",
                cust_data_filters.customer_type,
              ])
            );
          cust_data_filters.customer_desc &&
            cust_data_filters.customer_desc.length &&
            dispatch(
              setNielsenDataDropdown([
                "customer_desc",
                cust_data_filters.customer_desc,
              ])
            );
          cust_data_filters.kpis &&
            cust_data_filters.kpis.length &&
            dispatch(setNielsenDataDropdown(["kpis", cust_data_filters.kpis]));
          cust_data_filters.time_frames &&
            cust_data_filters.time_frames.length &&
            dispatch(
              setNielsenDataDropdown([
                "time_frames",
                cust_data_filters.time_frames,
              ])
            );
        }
        dispatch(setNielsenDropdownLoading(false));
      })
      .catch((err) => {
        console.error("Nielsen Customer Data Filters Dropdown API Failed", err);
        if (err.status === 403) {
          CheckAuthorization();
        }
        dispatch(setNielsenDropdownLoading(false));
      });
  };
//function for obtaining kpis dropdown data, calendar data in dynamic weekly scenario
export const getNielsenKPIs = (kpis_in_api) => async (dispatch, getState) => {
  dispatch(setNielsenDropdownLoading(true));
  CustomAxios(API.nielsen_kpis, "GET", kpis_in_api)
    .then((response) => {
      if (response.data.error_code === undefined) {
        let nielsen_kpis = response.data;
        dispatch(setNielsenKPIs(nielsen_kpis));
      }
      dispatch(setNielsenDropdownLoading(false));
    })
    .catch((err) => {
      console.error("Nielsen KPIs API Failed", err);
      if (err.status === 403) {
        CheckAuthorization();
      }
      dispatch(setNielsenDropdownLoading(false));
    });
};

export default nielsenfiltersSlicer.reducer;
